import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Moment from "moment";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Modal from 'react-bootstrap/Modal'
import i18n from "./DropdownLanguage/i18n";
class ServiceUpdateCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
      modalIsOpen: false
    };

  }

  componentDidUpdate(prevProps) {
    // Check if the currentPage has changed
    if (prevProps.currentPage !== this.props.currentPage) {
      // If the new currentPage is 1, reset pagination
      if (this.props.currentPage === 1) {
        this.setState({
          first: 0, // Reset to the first item
          rows: 10, // Reset rows if necessary (optional)
        });
      }
    }
  }
  renderPopover(props) {
    const { t } = this.props;
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{t('content.DownloadStatus')}</label>
        </Popover.Content>
      </Popover>
    );
  }
  renderviewships(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("PendingShipScreenContent.ViewShipDetails")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  render() {
    const { arraylist, pageSize, currentPage, totalRecords, t } = this.props;
    console.log(this.state.first);

    return (
      <div className="">
        <Modal
          size="md"
          show={this.state.modalIsOpen}
          onHide={() => this.setState({ modalIsOpen: false })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-sm">
              {t('content.MoreInformation')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table style={{ width: '100%' }}>
              <tr>
                <th>{t('ServiceUpdateContent.ShipEmail')}</th><td>mzil@mail.com</td>
              </tr>
              <tr>
                <th>{t('ServiceUpdateContent.ShipContactNumber1')}</th><td>9283928328</td>
              </tr>
              <tr>
                <th>{t('ServiceUpdateContent.ShipContactNumber2')}</th><td>7892703702</td>
              </tr>
              <tr>
                <th>{t('ServiceUpdateContent.SuperintendentEmail')}</th><td>mzil@mail.com</td>
              </tr>
              <tr>
                <th>{t('ServiceUpdateContent.SuperintendentPhone')}</th><td>7082730878</td>
              </tr>
              <tr>
                <th>{t('ServiceUpdateContent.FleetManagerEmail')}</th><td>mzil@mail.com</td>
              </tr>
              <tr>
                <th>{t('ServiceUpdateContent.TechnicalExecutiveEmail')}</th><td>mzil@mail.com</td>
              </tr>
              <tr>
                <th>{t('ServiceUpdateContent.VesselGroupEmail')}</th><td>mzil@mail.com</td>
              </tr>
              <tr>
                <th>{t('ServiceUpdateContent.CompanyDetails')}</th><td>Marine Mechanics Private Limited's </td>
              </tr>
              <tr>
                <th>{t('ServiceUpdateContent.InvoiceForwardingEmail')}</th><td>mzil@mail.com</td>
              </tr>
            </table>
          </Modal.Body>
        </Modal>
        {this.renderCardData()}
        {arraylist.data.length != 0 ? (
          <div className="mb-2">
            <Paginator
              first={currentPage}
              rows={pageSize}
              totalRecords={totalRecords}
              onPageChange={(e) => this.onPaginatorChange(e)}
            ></Paginator>
          </div>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                {t('CommonText.NoItem')}
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }

  onPaginatorChange(event) {
    
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);

  }

  renderCardData = () => {
    const { showSidePane, arraylist, isServiceDetail, t } = this.props;
    const isArabic = i18n.language === 'arab'
    return arraylist.data && arraylist.data.length
      ? arraylist.data.map((item, index) => {
        return (
          <div
            className="card mb-1"
            style={{ overflow: "hidden", position: "relative" }}
          >
            {/* {item.isContainAboveThreshold ? (
              <div className="arrow-left-red"></div>
            ) : (
                <div className="arrow-left-green"></div>
              )} */}
            <div className="p-3">

              <div className="resource-list-auth-date">
                <div className="row">
                  <div className={showSidePane ? "col-sm-9 col-md-9 col-9 col-m-auto" : "col-sm-10 col-md-10 col-10 col-m-auto"}>
                    <div className="row">
                      <div className="col-lg-12 mb-2">
                        <h6
                          className="resource-list-title"
                          onClick={() =>
                            this.ShowSidePanel(item.shipId)
                          }
                        >
                          {item.shipName !== "" ? item.shipName : ""}
                        </h6>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-2" : "col-sm-3 "
                        }
                      >
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong>{t("content.TotalEquipment")} </strong>
                          <strong>:</strong>
                          <span className="lato " >{item.total ? item.total : 0}</span>
                        </span>
                      </div>
                      <div className={showSidePane ? "col-sm-6" : "col-sm-3"}>
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong> {t("content.OverDueEquipment")} </strong>
                          <strong>:</strong>
                          <span className="lato " >
                            {item.overDue ? item.overDue : 0}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-2" : "col-sm-3"
                        }
                      >
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong>{t("content.EquipmentDuein30Days")} </strong>
                          <strong>:</strong>
                          <span className="lato " >
                            {item.in30Days ? item.in30Days : 0}
                          </span>
                        </span>
                      </div>
                      <div className={showSidePane ? "col-sm-6" : "col-sm-3"}>
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong>{t("content.EquipmentDuein90Days")} </strong>
                          <strong>:</strong>
                          <i aria-hidden="true"></i>
                          <span className="lato ">{item.in90Days ? item.in90Days : 0}</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  {isServiceDetail ?
                    <div
                      className={
                        showSidePane ? "col-sm-3 col-md-3 col-3 col-m-auto text-right mt-3 mb-3" : "col-sm-2 col-md-2 col-2 col-m-auto text-right"
                      } >
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderviewships()}
                      >
                        <i
                          className="fa fa-eye click px-1"
                          aria-hidden="true"
                          style={{ color: " #1a3464", fontSize: '1.8rem' }}
                          onClick={() =>
                            this.ShowSidePanel(item.shipId)
                          }>
                        </i>
                      </OverlayTrigger>
                    </div> : <div
                      className={
                        showSidePane ? " col-sm-3 mt-3 mb-3" : "col-sm-2 cl-2"
                      } style={{ maxWidth: '15%', marginTop: '0.7rem' }}>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderPopover()}
                      >
                        <i
                          className="fa fa-download click px-1"
                          aria-hidden="true"
                          style={{ color: " #1a3464", fontSize: '1.5rem' }}>
                        </i>
                      </OverlayTrigger>
                      <i
                        className="fa fa-info-circle click px-1"
                        aria-hidden="true"
                        onClick={() =>
                          this.setState({ modalIsOpen: true })
                        }
                        style={{ color: " #1a3464", fontSize: '1.8rem' }}
                      ></i>

                      <i
                        className="fa fa-eye click px-1"
                        aria-hidden="true"
                        onClick={() =>
                          this.ShowSidePanel(item.shipId)
                        }
                        style={{ color: " #1a3464", fontSize: '2rem' }}
                      ></i>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>

        );
      })
      : null;
  };
  ShowSidePanel = (shipId) => {
    this.props.dispatch({ type: "EditShipDetails", data: true });
    this.props.dispatch({ type: "IsServiceUpdate", data: true });
    this.props.dispatch({
      type: "MDSearchIsTrue",
      data: {},
    });
    //  this.props.history.push(`/Home/EquipmentEdit/${id}/${type}`);
    //  this.props.dispatch({ type: "ShowShipDetails", data: true });
    //  this.props.dispatch({ type: "Shipment Library", data: false });
    this.props.history.push(`/Home/ServiceShipDetails/${shipId}`);
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ServiceUpdateCard))
);
